import { put, call, takeEvery } from 'redux-saga/effects'

import {
  getDataSources as getDataSourcesApi,
  syncDataSource as syncDataSourceApi,
  connectDataSource as connectDataSourceApi,
  getEmailProviders as getEmailProvidersApi,
  disconnectDataSource as disconnectDataSourceApi,
  fetchPlaidConnections as fetchPlaidConnectionsApi,
  fetchWorkatoConnections as fetchWorkatoConnectionsApi,
} from 'Service/Api'

import * as DataSourceTypes from 'Redux/Types/DataSourceTypes'
import * as DataSourceActions from 'Redux/Actions/DataSourceActions'

function* getEmailProviders() {
  try {
    const { data } = yield call(getEmailProvidersApi)
    yield put(DataSourceActions.getEmailProvidersSucceeded(data))
  } catch (errors) {
    yield put(DataSourceActions.getEmailProvidersFailed(errors))
  }
}

function* getDataSources() {
  try {
    const { data } = yield call(getDataSourcesApi)
    yield put(DataSourceActions.getDataSourcesSucceeded(data))
  } catch (errors) {
    yield put(DataSourceActions.getDataSourcesFailed(errors))
  }
}

function* syncDataSource({ payload }) {
  try {
    yield call(syncDataSourceApi)
    yield put(DataSourceActions.syncDataSourceSucceeded(payload))
  } catch (errors) {
    yield put(DataSourceActions.syncDataSourceFailed(errors))
  }
}

function* connectDataSource({ payload }) {
  try {
    yield call(connectDataSourceApi, payload)
    yield put(DataSourceActions.connectDataSourceSucceeded(payload))
  } catch (errors) {
    yield put(DataSourceActions.connectDataSourceFailed(errors))
  }
}

function* disconnectDataSource({ payload }) {
  try {
    yield call(disconnectDataSourceApi, payload)
    yield put(DataSourceActions.disconnectDataSourceSucceeded(payload))
  } catch (error) {
    yield put(DataSourceActions.disconnectDataSourceFailed({ item: payload, error }))
  }
}

function* getPlaidConnections() {
  try {
    const { data } = yield call(fetchPlaidConnectionsApi)
    yield put(DataSourceActions.getPlaidConnectionsSucceeded(data))
  } catch (errors) {
    yield put(DataSourceActions.getPlaidConnectionsFailed(errors))
  }
}

function* getWorkatoConnections() {
  try {
    const { data } = yield call(fetchWorkatoConnectionsApi)
    yield put(DataSourceActions.getWorkatoConnectionsSucceeded(data))
  } catch (errors) {
    yield put(DataSourceActions.getWorkatoConnectionsFailed(errors))
  }
}

export default function* DataSourceSaga() {
  yield takeEvery(DataSourceTypes.GET_DATA_SOURCES, getDataSources)
  yield takeEvery(DataSourceTypes.SYNC_DATA_SOURCE, syncDataSource)
  yield takeEvery(DataSourceTypes.GET_EMAIL_PROVIDERS, getEmailProviders)
  yield takeEvery(DataSourceTypes.CONNECT_DATA_SOURCE, connectDataSource)
  yield takeEvery(DataSourceTypes.DISCONNECT_DATA_SOURCE, disconnectDataSource)
  yield takeEvery(DataSourceTypes.GET_PLAID_CONNECTIONS, getPlaidConnections)
  yield takeEvery(DataSourceTypes.GET_WORKATO_CONNECTIONS, getWorkatoConnections)
}
